/* SET STATE */
export const SET_STATE_LABTEST = "SET_STATE_LABTEST"

/* LABTESTS */
export const GET_LABTESTS = "GET_LABTESTS"
export const GET_LABTESTS_SUCCESS = "GET_LABTESTS_SUCCESS"
export const GET_LABTESTS_FAIL = "GET_LABTESTS_FAIL"

/* LABTESTSSAMPLES */
export const GET_LABTESTSSAMPLES = "GET_LABTESTS"
export const GET_LABTESTSSAMPLES_SUCCESS = "GET_LABTESTS_SUCCESS"
export const GET_LABTESTSSAMPLES_FAIL = "GET_LABTESTS_FAIL"

/* LABTEST */
export const GET_LABTEST = "GET_LABTEST"
export const GET_LABTEST_SUCCESS = "GET_LABTEST_SUCCESS"
export const GET_LABTEST_FAIL = "GET_LABTEST_FAIL"

/**
 * ADD LABTEST
 */
 export const ADD_NEW_LABTEST = "ADD_NEW_LABTEST"
 export const ADD_LABTEST_SUCCESS = "ADD_LABTEST_SUCCESS"
 export const ADD_LABTEST_FAIL = "ADD_LABTEST_FAIL"

 /**
 * UPDATE LABTEST
 */
export const UPDATE_LABTEST = "UPDATE_LABTEST"
export const UPDATE_LABTEST_STATUS = "UPDATE_LABTEST_STATUS"
export const UPDATE_LABTEST_SUCCESS = "UPDATE_LABTEST_SUCCESS"
export const UPDATE_LABTEST_FAIL = "UPDATE_LABTEST_FAIL"

/**
 * DELETE LABTEST
 */
export const DELETE_LABTEST = "DELETE_LABTEST"
export const DELETE_LABTEST_SUCCESS = "DELETE_LABTEST_SUCCESS"
export const DELETE_LABTEST_FAIL = "DELETE_LABTEST_FAIL"
